module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-richtext-e0736d7c.svg";